<div class="container">
    <div class="org-str">
        Organisation Structure
    </div>
    <div class="row" *ngIf="!loading">
        <ze-tree-table [treeData]="treeData" [showHeader]="false" [transformer]="transformer" [displayedColumns]="displayedColumns"></ze-tree-table>
    </div>
    <div *ngIf="!loading && error" class="text-danger">
        {{error}}
    </div>
</div>